import * as types from "../action/ActionType";
import type { AppAction } from "../action/ActionType";

export default function Requiredinvoice(state: unknown[] = [], action: AppAction): unknown[] {
  switch (action.type) {
    case types.REQUIRED_INVOICE:
      return action.payload;
    default:
      return state;
  }
}
